import { formatCurrency } from '@if/core/utils'
import { BodyText, DisplayValue, FieldSectionTitle } from '@if/mui'
import { Stack } from '@mui/material'
import { ComputeMechanicalWarrantyResultDto } from '@src/types/ComputeMechanicalWarrantyResultDto'
import { useTranslation } from 'react-i18next'
import WorksheetFundingSummaryCard from '../../components/WorksheetFundingSummaryCard'

interface Props {
  computedLoanAmounts: ComputeMechanicalWarrantyResultDto | null
  isComputing: boolean
}

const MechanicalWarrantyWorksheetLoanPaymentDetails = ({ computedLoanAmounts, isComputing }: Props) => {
  const { t } = useTranslation()

  const body = computedLoanAmounts ? (
    <Stack spacing={2}>
      <Stack spacing={0.5}>
        <FieldSectionTitle>{t('mechanicalWarrantyWorksheet.loanPaymentIs')}</FieldSectionTitle>
        <DisplayValue>
          {computedLoanAmounts.paymentAmount != null ? formatCurrency(computedLoanAmounts.paymentAmount) : ''}
        </DisplayValue>
      </Stack>
      <BodyText>{t('mechanicalWarrantyWorksheet.interestRate', { rate: computedLoanAmounts.interestRate })}</BodyText>
    </Stack>
  ) : null

  return (
    <WorksheetFundingSummaryCard
      title={t('worksheet.fundingSummary')}
      emptyMessage={isComputing ? t('common.loading') : t('mechanicalWarrantyWorksheet.incompleteForCalculation')}
      isReady={Boolean(computedLoanAmounts)}
    >
      {body}
    </WorksheetFundingSummaryCard>
  )
}

export default MechanicalWarrantyWorksheetLoanPaymentDetails
